import { render, staticRenderFns } from "./gdpr-policy.vue?vue&type=template&id=23c5e8b8"
import script from "./gdpr-policy.vue?vue&type=script&lang=js"
export * from "./gdpr-policy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports